import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Охотничий домик';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <h3>Hunting house</h3>

                    <h4>А. Описание возможностей проекта</h4>
                    <p>А1 Название проекта: <strong>Строительство охотничего домика</strong></p>
                    <p>(а) Краткое название: Охотничий домик</p>
                    <p>(b) Полное название: Строительство охотничего домика</p>
                    <p>(c) Краткое описание (аннотация). Деревянный сруб на 14 мест VIP. Отдых, охота, рыбалка</p>
                    <p>А2 Состояние проекта: Изучен рынок.</p>
                    <p>А3 Участвующие организации и их роль (контактные лица, телефон, факс, е-mail, страница в Интернет</p>
                    <ol>
                        <li>ООО «Янка» г. Брест ул. Советская 100 Тел. +375162 236454, +375162 219004, факс +375162 219008, yankahunt@tut.by  www.hunt.by, долевое участие, загрузка туристами.</li>
                    </ol>
                    <p>А4 Описание проекта (подходы, задачи, компоненты, результаты, этапы, сроки, общее финансирование, преимущества, влияние на переходные процессы в экономике и т.д.)</p>
                    <p>Срок реализации проекта 1 год. Общая стоимость проекта 150 тыс. дол. США. Преимущества: нет конкуренции, имеются свои клиенты</p>
                    <p>А5 Предпосылки (история, общая программа, взаимосвязанные или схожие проекты): Приоритет в развитии въездного туризма, налоговые льготы</p>
                    <p>А7 Возможные препятствия/проблемы/степень риска: Изменение законодательства</p>
                    <p>А8 Срок реализации и окупаемости проекта (лет): 3,5 года</p>
                    <p>А9 Отраслевая принадлежность проекта: туризм</p>

                    <h4>В. Статьи капитальных затрат (суммарные инвестиции, необходимые для реализации проекта):</h4>
                    <p>В1 Физические компоненты проекта (оборудование, работы, услуги и др. необходимые для реализации проекта): Основные средства (приобретение материалов, строительные работы, проектные работы)</p>
                    <p>B2 Капиталовложения (стоимость): 150 тыс. долл.</p>
                    <p>В4 Стоимость проекта: 150 тыс. долл.</p>
                    <p>Итого (должна равняться сумме С2+D4)</p>

                    <h4>С. Капитал по источнику происхождения, имеющейся в наличии инициаторов проекта (собственников, соучастников, спонсоров и т.п.)</h4>
                    <p>С1 Вид источников (гранты, инвестиции, долевое Участие/собственность и т. д.): долевое Участие</p>
                    <p>C2 Сумма: 20 тыс. долл.</p>

                    <h4>D. Требуемые инвестиции, недостающие средства</h4>
                    <p>D1 Недостаток финансовых средств, вид финансовой помощи (кредит, долевое участие и др.): Долевое участие</p>
                    <p>D4 Сумма: 130 тыс. долл.</p>

                    <h4>Е. Спрос (потребители) и доходы</h4>
                    <p>Е1 Тип потребителей (рынки), объемы, цены, доходы, начисляемая выгода(сбережения): Туристы (иностранные и граждане РБ Стоимость проживания 30$ Годовой доход (минимум) 43800$, другие услуги 2000 $ в год</p>
                    <p>Е2 Доходы (продажи): 45800 $</p>

                    <h4>F. Операционные и эксплуатационные расходы</h4>
                    <p>F1 Составляющие издержек, амортизационная политика, организация производства и др.: 3600 $ в год</p>

                    <h4>G. Чистый доход</h4>
                    <p>G1 Объем чистой прибыли (доходы Е2 минус операционные расходы F2): 42200 $</p>

                    <h4>Н. Источник информации о проекте</h4>
                    <p>Н1 Форма заполнения (кем, Ф.И.О., должность): Лобанов И.В., специалист по продажам</p>
                    <p>Н2 Организация (наименование и адрес): ООО «Янка» г. Брест ул. Советская 100</p>
                    <p>Н3 Тел. / факс / Е- mail: Тел. +375162 236454, +375162 219004, факс +375162 219008, yankahunt@tut.by  www.hunt.by</p>
                    <p>Н4 Дата: 24.06.06</p>
                    <p>Н5 Ведомственная принадлежность проекта: частный</p>
                </div>
            </div>
        </>
    );
}